import { HttpClient } from "@angular/common/http";
import { Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { createAction, Store, props } from "@ngrx/store";
import { AuthService } from "@app/core/authentication";

@Component({
  selector: "app-client-layout",
  templateUrl: "./client-layout.component.html",
  styleUrls: ["./client-layout.component.scss"],
})
export class ClientLayoutComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  setConfig = createAction("[Config] Set Config", props<{ userData: any }>());
  apiUrl: string;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private authService: AuthService,
    private store: Store<{ config: any }>
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.store.select("config").subscribe((res) => {
        this.apiUrl = res.apiUrl;
      })
    );

    const userToken = this.route.snapshot.queryParams["token"];
    this.authService.clientUserSubject.next({
      data: {
        token: userToken,
      },
    });
    this.store.dispatch(this.setConfig({ userData: { data: { userToken } } }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
